//
// Images
// --------------------------------------------------
import { css } from 'styled-components';
export var imageStyle = function imageStyle() {
  return css(["vertical-align:middle;"]);
};